import { render, staticRenderFns } from "./ButtonSquare.vue?vue&type=template&id=13bd391c&"
import script from "./ButtonSquare.vue?vue&type=script&lang=js&"
export * from "./ButtonSquare.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSquare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports